import { CheckCircle2, Loader2, XCircle, Clock, X } from "lucide-react";

const STATUS = {
  queued: { icon: Clock, cls: "text-zinc-500", label: "queued" },
  running: { icon: Loader2, cls: "text-emerald-500 animate-spin", label: "decoding" },
  done: { icon: CheckCircle2, cls: "text-emerald-500", label: "done" },
  error: { icon: XCircle, cls: "text-red-400", label: "failed" },
};

const th = "text-left font-mono-display text-[10px] tracking-[0.25em] uppercase text-zinc-500 font-normal px-4 py-3";
const td = "px-4 py-3 font-mono-display text-sm align-top";

export const BatchResults = ({ items, onOpen, onClose }) => {
  const done = items.filter((i) => i.status === "done").length;
  return (
    <div className="border border-white/10 bg-zinc-900/40 rounded-sm" data-testid="batch-results">
      <div className="px-5 py-4 border-b border-white/10 flex items-center">
        <span className="font-mono-display text-[10px] tracking-[0.3em] uppercase text-zinc-500">batch // side-by-side</span>
        <span className="ml-auto font-mono-display text-[10px] tracking-[0.2em] uppercase text-emerald-500" data-testid="batch-progress">
          {done}/{items.length} decoded
        </span>
        {onClose && (
          <button type="button" onClick={onClose} aria-label="Close batch" data-testid="close-batch-btn"
            className="ml-3 h-8 w-8 flex items-center justify-center text-zinc-500 hover:text-white hover:bg-white/5 transition-colors">
            <X className="w-4 h-4" />
          </button>
        )}
      </div>
      <div className="overflow-x-auto">
        <table className="w-full min-w-[640px]">
          <thead className="border-b border-white/5">
            <tr><th className={th}>song</th><th className={th}>bpm</th><th className={th}>key</th><th className={th}>mood</th><th className={th}>genre</th><th className={th}>status</th></tr>
          </thead>
          <tbody>
            {items.map((item, i) => {
              const s = STATUS[item.status];
              const a = item.result;
              return (
                <tr
                  key={item.id}
                  onClick={() => a && onOpen(a)}
                  data-testid={`batch-row-${i}`}
                  className={`border-b border-white/5 transition-colors ${a ? "cursor-pointer hover:bg-emerald-500/5" : ""}`}
                >
                  <td className={`${td} text-white max-w-[200px] truncate`}>{a?.title || item.name}</td>
                  <td className={`${td} text-emerald-500 whitespace-nowrap`}>{a?.bpm || "—"}</td>
                  <td className={`${td} text-emerald-500 whitespace-nowrap`}>{a?.key || "—"}</td>
                  <td className={`${td} text-fuchsia-300`}>{a?.mood || "—"}</td>
                  <td className={`${td} text-zinc-300`}>{a?.genre || "—"}</td>
                  <td className={td} title={item.error || ""}>
                    <span className="flex items-center gap-1.5 text-[10px] uppercase tracking-[0.15em] text-zinc-400">
                      <s.icon className={`w-3.5 h-3.5 ${s.cls}`} />{s.label}
                    </span>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
      <p className="px-5 py-3 text-[11px] font-mono-display text-zinc-500">Click a decoded row to open its full prompt, timeline and lyrics.</p>
    </div>
  );
};
